
import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;
const Loader = styled.div`
    width: 18px;
    height: 18px;
    border: 2px solid ${(props) => props.theme.colorWhite};
    border-top: 2px solid transparent;
    border-radius: 50%;
    animation: ${spin} 0.6s linear infinite;
`;

const ButtonLoader = () => {
    return (
        <Loader />
    )
}
export default ButtonLoader
